module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RYN")])]), _vm._v(" caught a glimpse of herself in the hall mirror as she headed toward the front door, the doorbell still ringing as she padded along the carpetless hall. Sheen of white dress, brilliant blue eyes, flushed cheeks. A radiant bride. And she did feel beautiful, more beautiful than she had in years. In just seven short days she’d be a bride again. She’d be Stanley’s wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smiling, Bryn hummed the wedding march as she swung the front door open, late-afternoon sunlight washing over her in streaky gold waves, briefly blinding her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blinking, she made out broad shoulders. The high curve of cheekbone. A beautifully shaped mouth. And only one man had that mouth. Her heart staggered to a stop. “Wh…what…are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, darling. It’s nice to see you, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Time stopped, changed, and for a split second she was somewhere else, spellbound. It was just like the day she met him, the day she reversed her small Volkswagen, and slammed into his silver Mercedes Benz. Her car was totaled. His was merely dinged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bryn felt the impact again, the air knocked out of her lungs, her lips parting in shock. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Kahlil.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_vm._v("“You remembered, good.” He looked amused, but then, his gold eyes always smiled when he was angry. ")]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("Lifting a sheet of paper, he dangled it in front of her face. “Now perhaps you’ll remember this,” he drawled softly, giving the paper a gentle shake.")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bryn stared at the paper blankly, unable to read the words. Only his voice penetrated the muddle inside her head, his voice still husky, his English formal, the same English he’d learned as a child in an English boarding school. “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t recognize it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her fingers felt nerveless as she clutched the door. “No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil chuckled, the sound warm, indulgent, an indulgence he’d shown toward her early in their marriage when she’d been his prized American bride. “It’s our marriage license. The little piece of paper that legally binds us together.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t speak, her throat swelling closed. He must be out of his mind, she thought, forcing herself to look into his face, meet his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t look crazy. If anything he looked calm, perfectly controlled, as though he knew exactly what he was doing, as though he’d planned this surprise visit on purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A week before her wedding…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her thoughts spun, her brain fogged by shock and fear. What if Kahlil discovered Ben? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What if he found out about their son?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("No. She’d never go back to him. Never return to Zwar. Bryn drew herself tall, conviction making her ")]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("back straight, her determination reinforcing her courage. “I don’t understand what that has to do with us.”")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everything, darling.” He was gazing down at her with considerable interest, thick black lashes fanning his carved cheekbones and the bronzed luster of his skin. “I’ve come to see why you’re getting married again when you’re still married to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still married to him? Ridiculous. If he thought he could hoodwink her with a silly statement like that, then he had another thing coming. She wasn’t eighteen anymore. She wasn’t a child bride, either. “We’re not married,” she said crisply, disdain sharpening her voice. “We were divorced three years ago.” How could he still refuse to accept their divorce? It’d been three years, more than three years. Three and a half years, actually. “I’m not in the mood for games. Perhaps in Zwar, divorces aren’t permitted, but here they’re perfectly legal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, darling, I understand that much. And perhaps you’ve forgotten I have a law degree from Harvard, an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American")]), _vm._v(" university, and despite my Arab nationality, I grasp the legality of an American divorce, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we")]), _vm._v(" were never divorced.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a quiet menace in his voice, a menace she heard all too clearly. Her head jerked up, her gaze clashing with his. “If this is your idea of a joke—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Have I ever been a comedian?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, she answered silently, bitterly. He was one man in desperate need of a sense of humor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("“I’m trying to prevent you further embarrassment,” ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("he added with the same infuriating calm. “I considered waiting until you’d arrived at the church, the guests filling the pews. I could just picture your eager groom at the altar, standing there in his black-and-white tux—he is wearing a tuxedo, isn’t he?”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t bear to be the brunt of Kahlil’s scorn. She’d witness him level others in the past, but never her. Kahlil had never been anything but protective, generous, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("loving.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart squeezed on the last one, pained by the unwanted memory. Their marriage had been brief. Too brief but she couldn’t go back, couldn’t undo the past. “I think it’s time you left.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put his hand in the door to keep her from shutting it in his face. “I’ve tried to be polite, but perhaps it’s better if I’m blunt. There will be no wedding next Saturday. And as long as I live, there will be no wedding to any man, ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She ground her jaw together, struggling to contain her temper. Maybe in his country men could veil their women, tell them how to dress, what to think, where to go, but not in the United States, and not in her home. “I don’t belong to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually, in Zwar, you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“People are not objects, Kahlil!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("Pushing the door all the way open, he picked her up, hands encircling her rib cage, thumbs splayed beneath her breasts. His fingers felt like fire against her skin, searing straight through the bodice of her gown. Her breasts tingled, her senses responding to him just as ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("they’d always responded to him. He could turn her into puddles of need in no time flat.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil tipped her backwards just enough to knock her off her feet, and sent her heart racing. “How could you possibly think I’d let you marry another man? How could you think I’d give you up?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because the divorce—” she choked, beginning to feel genuinely frightened, not by him but by the idea of still being married to him. Their marriage was over; it had to be over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What divorce?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The divorce…our divorce.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dark hallway threw sinister shadows across his face. “There was no divorce. You never returned the last of the paperwork, and with documents unsigned the divorce was dropped.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her mouth dried. Her heart hammered harder. She could feel every ragged beat, every quick painful surge of blood. “Documents?” she stuttered, repeating the word as though it were foreign.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I contested the divorce, refused to accept that you’d left me. It wasn’t desertion, I told the judge, but a temporary leave of absence. The judge sent you paperwork and you never filled it out. Therefore the divorce wasn’t granted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You bought the judge. You gave him money—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t get carried away. Your legal system isn’t all that corrupt. If you want to place blame, place it on your shoulders.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d rendered her speechless, stole her breath, her words, her anger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Could he be possibly right? Had she somehow let paperwork slip?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her brain raced, struggling to remember that first year, those horrible months of struggling with the baby on her own. She’d moved a half-dozen times in as many months, did temp jobs on top of her regular job just to pay her bills. Swallowing hard Bryn found her voice. “I didn’t know you could contest a divorce in Texas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In Texas, anything’s possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She suddenly saw him scooping Ben into his arms, boarding his private jet and taking off. He’d have Ben. She’d never see him again. The vision was so awful, so vivid and real, it felt as though he’d thrust his dagger, the one he wore beneath his robes, straight through her heart. “Why are you doing this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His gold-flecked gaze slowly moved across her face, scrutinizing. “You married me. You understand the vows. I’m keeping the vows. And so are you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll never live with you again, Kahlil.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you are my wife. You’ll remain my wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She crossed her arms over her chest chilled to the bone. A life tied to him. It would be a life in chains. And Ben…she closed her eyes, unable to bear the thought of Ben trapped with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her lashes lifted, her gaze fixed on her husband’s face. She’d once found him impossibly beautiful. Now she found him impossibly frightening. “What do you want?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her stomach fell, plummeting to her feet. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Never. Ever, ever.")]), _vm._v(" She dug her fingers into her bare upper arms, fingers pressing into muscle, nails into firm flesh. “It’s not going to happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled, a small, hard, uncompromising smile. “It will. I’ll bet my life on it.” Kahlil moved to the door, opened it and stepped onto the small cement porch. “I’ll send my car for you tomorrow. We’ll have dinner, discuss the future.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lunged toward him, fists clenched. “There is no future!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, yes, there is. How does seven o’clock sound?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d have Ben here then. It would be his bathtime, then stories and bed. She couldn’t possibly go out, couldn’t possibly let Kahlil return here, either. “You can’t just bully your way back into my life. If what you say is true…” Her voice fell away. She swallowed hard, unable to fathom such a truth. After a tense silence she forced herself to continue. “I need time. I need to make some calls, and of course, there is Stan—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, yes, nice old Stanley Hopper. Your boss, your fiancé, your insurance agent.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shrugging he reached for the doorknob, twisting it open. “I’m staying at the Four Seasons. I won’t leave town until we’ve sorted matters out.” He leaned over, dropped a kiss on her parted lips. “By the way, you look lovely in that dress.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("She’d forgotten all about her wedding gown. Self-")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("consciously she pressed the skirt smooth, the silk delicate and light beneath her fingertips. She’d been trying it on, making sure it didn’t need any last-minute alterations. “I wanted to see if it fit.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It fits.” He smiled, eyes glinting. “Beautifully.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bryn was still shaking an hour after Kahlil finally left. She’d changed, made a cup of tea, but couldn’t relax, couldn’t calm down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil was wrong, he had to be wrong. She wasn’t married to him. She wasn’t his wife. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("couldn’t")]), _vm._v(" be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her thoughts raced here, there, scattering in a thousand directions as she drove to Ben’s preschool to pick him up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she were really still Kahlil’s wife, then Kahlil would have a legal right to see Ben. To take Ben.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Making dinner that night Bryn battled to hide her worry from Ben. The cheerful chatter she usually enjoyed grated on her and she was relieved when he finally went to bed and she had some quiet to think.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She paced the small living room, chewing on her thumbnail. The only way she could protect Ben from danger was to keep him a secret, and she didn’t know how she’d managed to hide Ben, but she had to. She just had to.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Bryn took the next day off from work and spent it making phone calls—to the courthouse, to lawyers, to anyone who might be able to help her sort out the facts regarding her divorce. With horror she heard one clerk after another explain that paperwork was indeed missing ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("and that the divorce suit had been dropped over a year ago.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then Kahlil was right. The marriage, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("their")]), _vm._v(" marriage, still existed, under Texas law.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It took her another two days to accept the terrible truth. Two days of a churning stomach, and two awful, endless, sleepless nights when she cursed herself for not being on top of details, for failing to ensure the divorce was finalized. This was her fault, her fault entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, heart aching, Bryn called Stan and broke the news. He immediately drove over and they talked for hours but in the end the facts remained the same and there was nothing they could do but postpone the wedding. Stan behaved like a true gentleman, offering no reproaches, just promising his full support.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But after he left, and the house was silent again, Bryn knew she had one last painful phone call to make.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She called the Four Seasons Hotel and was put through to Kahlil’s presidential suite. If he sounded surprised to hear from her he gave no indication. But Bryn wasn’t about to chitchat. Her voice cool, her tone formal, she suggested they meet the following night for dinner and named a popular Dallas restaurant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil offered to send a car, she refused. She’d drive there, she told him, drive home and that would be the last time she’d see him again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("But dinner the next evening didn’t start off the way she’d planned. First her car wouldn’t start, and then instead of dropping Ben off at the baby-sitter’s house, she had to call and ask the sitter to come for Ben. Finally ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("she was forced to phone Kahlil and leave word at the restaurant that she’d be late due to car difficulties. Before the taxi arrived, a black limousine pulled up in front of her house. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kahlil.")]), _vm._v(" She knew it without a glimpse of him, knew it without a word from him. She felt him. Felt his strength, his anger, his conviction.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the living-room window she saw him step out of the back and stand next to the limousine’s open door. He didn’t move. He didn’t speak. He simply waited, and in his aggressive stance she saw ownership. He was stating his belief, that she was his, and only his.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil wasn’t going to go away. He wasn’t going to leave her alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The black limousine sailed on and off the freeway, winding through traffic but Bryn couldn’t concentrate on anything. She heard Kahlil say he’d changed their dinner reservation to another restaurant, a quieter one, more conducive to conversation. He said something about taking care of unfinished business but she couldn’t think about that, couldn’t possibly consider anything between them unfinished. In her mind they were done. Dead. Over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not by her choice. It had never been her choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The limousine dropped them in front of an exclusive Dallas restaurant, a restaurant requiring membership, and a critical screen before a member could be accepted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("The restaurant entrance was so discreet it looked like a warehouse entrance. However, Bryn found that behind the plain concrete walls and studded steel door, the restaurant walls had been painted in gleaming shades of ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("blue and gold and the gold-leafed ceiling glittered with dozens of extravagant crystal chandeliers.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hungry?” Kahlil asked, his hand resting on the small of her back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt every muscle in her tighten, her body snapping to response and Bryn jerked away from him, shocked by her sensitivity. She shouldn’t still feel this way. She shouldn’t still feel anything. “No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The maître d’ murmured polite greetings, ushering them to a curtained booth. The heavy drapes could be closed, making the table more intimate, if required.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seated, Bryn’s gaze darted to the thick purple drapes, praying they’d remain open, tied back with the gold tasseled ropes. Kahlil ordered drinks for them, and an appetizer. Her hands shook beneath the table. She struggled to breathe normally.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Smile,” he said, leaning back against the plush seat upholstery. “You look like you’re being tortured.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am being tortured. This is torture.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How far we’ve come,” he mocked, dark head tipping, black lashes lowering as he studied her grim expression. “Once you would have died for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I almost died living with you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she didn’t say it. He knew nothing about her last night in Tiva, or her friendship with his cousin, a friendship that proved to be a terrible, nearly tragic mistake. “You can’t take over my life, Kahlil. It’s been three years, three and a half years, since we were together. I’ve changed—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, you’ve grown rebellious.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve just grown up. I won’t take orders from you anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I never had to order you to do anything. You did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("everything")]), _vm._v(" for me,” and his accented voice caressed the word everything, “eagerly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her stomach clenched. She wouldn’t think about the past, wouldn’t think about their old relationship. “Kahlil, I want a divorce and I am going to file for one first thing in the morning. Stan knows an excellent lawyer and he and I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")]), _vm._v(" be married eventually.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil made a rude sound, deep in his throat. “I hope your Stan is a patient man because he’s going to be kept waiting a very long time. I’ll tie you up with every legality I can. You name it, I’ll do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stared at him as though he were the devil himself. “Why? What have I ever done to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His golden gaze raked her bare shoulders and simple black dress. “You broke your word.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So that was it. This was just about revenge. About inflicting pain. Fear balled in her stomach and she realized yet again how dangerous this was for Ben.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The appetizer arrived, a savory baked crab dish with buttery crumbs and cheese. Bryn normally loved crab but at the moment her stomach was so queasy she could barely tolerate the smell, much less eat. Kahlil, she noticed, took none, either. “I thought you were famished.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am. I’m waiting for you to serve me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As if she was one of the women from his harem! Incredible. “You are not helpless, Sheikh al-Assad!”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But why should I serve myself when you are here to serve me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glared at Kahlil, resenting his beauty, the black hair, the strong brow, the elegant sweep of cheekbone. She’d fought so hard to free herself, ripped her heart in two to escape him. It had taken her years to move forward and now that she finally was ready to marry again, he’d returned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Treacherous man. Man that could disarm her with just a glance from his beautiful eyes. She’d loved him too much, needed more from him than he could give.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blindly she stumbled to her feet, her long black dress tangling between her legs. His hand snaked around her wrist and drew her roughly down again. “You are not excused.” His dark eyes flashed at her, deep grooves etched on either side of his imperious mouth. “You did not ask my permission to leave the table.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve never asked your permission for anything and I’m not about to start now!” Good God, who did he think he was? Bryn threw her head back, tears shimmering in her eyes. “I can’t believe I once imagined myself in love with you. What a fool I was!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t imagine it. You did love me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did,” she repeated bitterly, “as in past tense. I only feel hatred for you now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("“Love, hate, who cares? I’m more interested in ensuring you honor your vows.” His anger emanated from him in great silent waves. “I realize you were very young when we married but I’ve given you time to grow ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("up. Three and a half years. Now I’ve come to bring you home.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Zwar is not my home!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He snapped his fingers. “Semantics,” he said brusquely. “I’m tired of debating. The fact is your place is in Tiva, at the palace, bearing my children.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That is one scenario which will "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think you’d be happier married to your pathetic little insurance agent? I’ve had my intelligence look into him and he’s a man without fire, a man without drive—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I love him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t care. You can’t have him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anger swept through her, anger so strong that she lifted her hand and took a swing at his face. He caught her by the wrist just before she struck his cheek. “Have you lost your mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her wrist tingled from the tightness of his grip, his fingers wrapped viselike around her fragile bones. “Leave Stan alone. He doesn’t deserve this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you do. You’ve insulted me, and my family. You had a responsibility—you were Princess al-Assad—and you abandoned my people.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her wrist began to throb. Tiny pinpricks flashed against her closed eyelids. “Please, release me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I expect an apology.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re hurting me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His nostrils flared, his dark eyes flashing, but he opened his fingers, freeing her wrist. She drew her arm back to her lap and stared at her wrist, seeing the livid marks of his fingers against the paleness of her skin.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil dragged the heavy velvet drapes closed. The violet-purple fabric fell in deep inky folds, hiding them from the rest of the restaurant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was pulling her back into his world, forcing her to submit. She couldn’t let him. She wasn’t just his wife. She was a mother, Ben’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The tears that she’d fought so hard to contain trembled on her lashes, slipping free. She pressed her lips together, fighting to keep control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do not cry,” he said roughly. “I won’t have my wife weeping in public.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve drawn the drapes. No one can see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Everything about him was so hard. Every word sounded harsh. She clamped her jaw shut, refusing to engage in a battle of wills with Kahlil. He was a far better debater than she. He was far better at everything than she, but that didn’t make his needs more important, his feelings more correct.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kahlil must have accepted her silence for submission as his hard expression gentled a fraction. “If you don’t want a fight, don’t provoke me. I didn’t travel all this way to be scorned by a woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had he always been so arrogant? So damned condescending? Maybe once she’d found his machismo attractive but now it filled her with terror. Terror not just for herself, but Ben, and Ben’s future.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("If Kahlil knew he had a son, he’d insist that Ben be raised in Zwar, his small oil-rich kingdom in the Middle ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("East. Zwar was beautiful but far removed from the freedom she and Ben knew in Texas.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Abruptly Kahlil leaned forward, grasped her chin, drawing her toward him. She nearly flinched, inwardly shrinking from his touch, but steeled herself outwardly, not wanting him to know how strongly he affected her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet when he stroked her lips with the pad of his thumb, her whole body shuddered, a response she couldn’t possibly hide from Kahlil.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve become quite skittish,” he drawled, clearly intrigued. “Doesn’t Stan ever touch you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My relationship with Stan is none of your business.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A bold answer for a woman in a precarious position.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her lips twisted, her smile forced. She ignored the truth in this, realizing she was indeed caught, but pride overwhelmed her common sense. She couldn’t back down. “I have changed, Kahlil. I’m not the girl you married.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good. Then we both have adjustments to make. I’m not the man you married, either.” He smiled without humor, his gaze never wavering from her face. “And you have changed. You’ve grown more beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t flatter me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not flattering you. I’ve met a lot of women in my life, but I’ve never met another woman like you. No one with your sweetness, softness—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Stop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your pale, flawless skin. Your eyes, the dark blue of precious sapphires. Your mouth softer than a rose.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her spine tingled, her skin prickling. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t listen to this.")]), _vm._v(" Don’t let him get under your skin. You’ve survived him once. You can do it again. “You only want me because you can’t have me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His fingers opened, freeing her, and his smile remained the same. But his eyes looked harder, the glints brighter. “I can have you. I just haven’t been aggressive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, he’d never been aggressive with her before tonight, but she suddenly knew he could be extremely ruthless, correctly reading the menace in his hard features, and danger in the crooked curve of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His smile faded. “Does Stan know you’re a flighty little wife?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, low blow. “He knows I left you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you tell him you left without leaving a note? Or giving me a kiss goodbye? He knows you just took your purse, your passport and walked?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He knows I took my purse and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ran.")]), _vm._v("” Her gaze locked with his. If he wanted to make it tough, she could play tough. That’s all she’d been doing since leaving Zwar anyway. Cutting coupons to buy breakfast cereal. Shopping for clothes from a secondhand store. Working double shifts at the insurance agency. She’d shouldered parenthood on her own, and succeeded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did Stan ever ask why you left me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He knew I was unhappy, and that was enough for him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Kahlil lifted his wine goblet, swirled the glass, ruby-red wine shimmering in the candlelight. “What an un")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("derstanding man. Will he be so understanding when you toss him away, tired of that marriage, too?”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His sarcasm was as sharp as razor blades and cut deep. If she thought she could get away with it, she’d run. But she wouldn’t get away from Kahlil, not like that, not this time. “I never tossed you away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No? It felt that way. It looked that way, too. The palace was wild with gossip. The scandal affected the entire kingdom. I didn’t just lose face. My people lost face.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What scandal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rumor has it you were…unfaithful.”")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01ce684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426886430_ch01.vue
// module id = 69
// module chunks = 0